import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';
import { FastField } from 'formik';
import { useDropzone } from 'react-dropzone';

const Component = ({ field, form, ...props }) => {
  const onDrop = React.useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];

      if (file) {
        form.setFieldValue(field.name, file);
      }
    },
    [field.name, form],
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: props.accept.split(', '),
  });
  return (
    <div {...getRootProps()}>
      {props.disabled ? null : <input {...getInputProps()} />}

      <TextField
        disabled={props.disabled || form.isSubmitting}
        label={props.label}
        value={
          props.value &&
          (typeof props.value === 'string' ? props.value : props.value.name)
        }
        fullWidth
        variant="outlined"
        error={Boolean(form.errors[field.name])}
        helperText={form.errors[field.name]}
      />
    </div>
  );
};

Component.propTypes = {
  accept: PropTypes.string.isRequired,
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};

const FileUpload = React.memo((props) => {
  return (
    <FastField {...props} component={(p) => <Component {...props} {...p} />} />
  );
});

FileUpload.propTypes = {
  accept: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default FileUpload;
